import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-more-button',
    templateUrl: './more-button.component.html',
    styleUrls: ['./more-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoreButtonComponent {
  @Input() label: string;
  @Output() moreEvent: EventEmitter<boolean> = new EventEmitter();

  onMoreClicked() {
    this.moreEvent.emit();
  }

}
